/* @flow */
import React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import { defineMessages, FormattedMessage } from 'react-intl';

import Localizable from 'lib/intl/localizable';
import Styled from 'lib/styles/styled-deprecated';
import withDialog from 'lib/alerts/with-dialog';
import { InfoDialog } from 'lib/alerts/dialog';
import withInnerRef from 'lib/react/with-inner-ref';
import SvgIcon from 'lib/images/svg-icon/svg-icon';

import defaultStyles from './file-input.scss';

@Localizable()
@withDialog
@withInnerRef()
@Styled(defaultStyles)
@observer
class FileInputView extends React.Component {
    static defaultProps = {
        multiple: true,
    };

    setInput = ref => {
        this.ref = ref;
    };

    @action onChange = event => {
        if (this.props.onChange) {
            this.props.onChange(event);
        }

        const { limit, accept, replace } = this.props;
        const files = [];

        if (event.target.files) {
            if (limit || accept) {
                for (let i = 0; i < event.target.files.length; i++) {
                    const file = event.target.files[i];
                    files.push(file);

                    if (limit) {
                        if (file.size / 1024 / 1024 >= limit) {
                            this.props.showDialog(
                                new InfoDialog({
                                    message: this.props.intl.formatMessage(
                                        defineMessages({
                                            FORM_ERROR_TEXT_FILE_TO_BIG: { id: 'FORM_ERROR_TEXT_FILE_TO_BIG' },
                                        }).FORM_ERROR_TEXT_FILE_TO_BIG,
                                        {
                                            name: file.name,
                                            limit,
                                        }
                                    ),
                                })
                            );

                            return null;
                        }
                    }

                    if (accept) {
                        const items = accept.split(',');

                        for (let j = 0; j < items.length; j++) {
                            const item = items[j];

                            if (
                                (item.startsWith('.') && !file.name.endsWith(item)) ||
                                !file.type.startsWith(item.replace('/*', ''))
                            ) {
                                this.props.showDialog(
                                    new InfoDialog({
                                        message: this.props.intl.formatMessage(
                                            defineMessages({
                                                FORM_ERROR_TEXT_FILE_NOT_ACCEPTED: {
                                                    id: 'FORM_ERROR_TEXT_FILE_NOT_ACCEPTED',
                                                },
                                            }).FORM_ERROR_TEXT_FILE_NOT_ACCEPTED,
                                            { name: file.name }
                                        ),
                                    })
                                );

                                return null;
                            }
                        }
                    }
                }
            }

            const items = this.props.fieldDataForFiles({ files });
            if (replace) {
                this.props.field.data
                    .replace(items)
                    .catch(err => {
                        if (this.props.onCancelError) {
                            this.props.onCancelError(err);
                        }
                    })
                    .then(result => {
                        if (this.props.onCancel) {
                            this.props.onCancel(result);
                        }
                    });
            } else {
                this.props.field.data.push(...items);
            }

            return null;
        }
    };

    onClick = event => {
        if (this.ref) {
            this.ref.value = null;
        }

        if (this.props.onClick) {
            this.props.onClick(event);
        }
    };

    render() {
        const {
            accept,
            multiple,
            intl: { _ },
            styles,
            icon,
        } = this.props;

        return (
            <span className={styles.fileInput}>
                <label onClick={this.onClick}>
                    <div className={styles.button}>
                        <FormattedMessage id='THREAD_ADD_IMAGES' values={{ gender: 'v' }} />
                        <SvgIcon src={icon} className={styles.icon} />
                    </div>

                    <input
                        ref={this.setInput}
                        className={styles.input}
                        type='file'
                        accept={accept}
                        multiple={multiple}
                        onChange={this.onChange}
                        onClick={this.onClick}
                    />
                </label>
            </span>
        );
    }
}

export default FileInputView;
